module.exports = __webpack_public_path__ + "static/media/ST5-BG1.72cda97d.jpg";